import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove, CheckBox } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import MapPinLocation from "../../../shared/components/MapPinLocation.tsx";

import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

import customParseFormat from 'dayjs/plugin/customParseFormat';
import Autocomplete from "@mui/material/Autocomplete";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { autoTable } from "jspdf-autotable";
import PictureAsPdf from "@mui/icons-material/PictureAsPdf";

import { useNavigate } from "react-router-dom";

import { WorkspaceSearchParams, getWorkspace, createWorkspace, uploadWorkspacePhoto, editWorkspace, fetchWorkspacePhotoBlob, deleteWorkspace, CleaningSearchParams, getCleaning, createCleaning, editCleaning, deleteCleaning } from "../services/workspaceService.tsx";
import { fetchAhs } from "../../sales/services/ahsService.tsx";
import { fetchEmployees, getEmployees } from "../../data_management/services/employeeService.tsx";
import { getOfficeProjects } from "../services/projectDetailServices.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';
import LoadingOverlay from "../../../shared/components/LoadingOverlay.tsx";

const grafanaURL = process.env.REACT_APP_GRAFANA_URL || "http://localhost:3030";

// Dummy Data
const rabReviewData = [
  {
    keterangan: "Sewa Perancah",
    volume: 1,
    satuan: "Ls",
    hargaSatuan: 5000000,
    jumlahHarga: 5000000
  },
  {
    keterangan: "Pembongkaran Atap",
    volume: 30,
    satuan: "M2",
    hargaSatuan: 1000000,
    jumlahHarga: 30000000
  },
  {
    keterangan: "Pemasangan Seng",
    volume: 580,
    satuan: "LS",
    hargaSatuan: 1000000,
    jumlahHarga: 580000000
  }
];

const jumlahHarga = rabReviewData.reduce((acc, curr) => acc + curr.jumlahHarga, 0);
const ppn = Math.round(jumlahHarga * 0.11);
const totalHarga = jumlahHarga + ppn;

const sCurveData = [
  {
    category: "Pekerjaan Persiapan",
    keterangan: "Sewa Perancah",
    nilai: 5000000,
    bobot: 0.75,
    bobotMinggu: 0.04,
    durasi: "3 Weeks",
    start: "01/07/2021",
    end: "22/07/2021"
  },
  {
    category: "Pekerjaan Atap",
    keterangan: "Pembongkaran Atap",
    nilai: 10000000,
    bobot: 1,
    bobotMinggu: 0.5,
    durasi: "2 Weeks",
    start: "01/07/2021",
    end: "15/07/2021"
  },
  {
    category: "Pekerjaan Atap",
    keterangan: "Pemasangan Seng",
    nilai: 1000000,
    bobot: 90,
    bobotMinggu: 90,
    durasi: "1 Weeks",
    start: "01/08/2021",
    end: "08/08/2021"
  }
];


const projectTypeColors = {
  "PST": "green",
  "MB": "lightgreen",
  "PJTK": "#164396  ",
  "KON": "gray",
  "SK": "orange"
};

const statuses = ["Not Approved", "Approved", "Rejected"];
const projectTypes = ["Residential", "Commercial", "Infrastructure", "Industrial"];
const constructionPhases = ["Planning", "Design", "Procurement", "Execution", "Finishing"];
const pembebanan = ["SPP", "Pemberi Kerja", "Dana Pensiun"];
const periode = [
  "Pukul 06.00 s/d 08.00 WIB",
  "Pukul 11.00 s/d 13.00 WIB",
  "Pukul 16.00 s/d 18.00 WIB"
]

const WorkspacePage: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddWorkspaceDialog, setOpenAddWorkspaceDialog] = useState(false);
  const [isApprover, setIsApprover] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);


  const [officeFilter, setOfficeFilter] = useState("");
  const [workspaceFilter, setWorkspaceFilter] = useState("");
  const [floorFilter, setFloorFilter] = useState("");
  const [periodeFilter, setPeriodeFilter] = useState("");

  const [indexRowOnEdit, setIndexRowOnEdit] = useState<number>();
  const [indexRow, setIndexRow] = useState<number>();

  const [isEditRow, setIsEditRow] = useState(false);
  const [isEditRowOnEdit, setIsEditRowOnEdit] = useState(false);


  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [startDateS, setStartDateS] = useState<string | null>(null);
  const [endDateS, setEndDateS] = useState<string | null>(null);

  const [startDateE, setStartDateE] = useState<string | null>(null);
  const [endDateE, setEndDateE] = useState<string | null>(null);

  const [startDateCleaning, setStartDateCleaning] = useState<string | null>(null);
  const [endDateCleaning, setEndDateCleaning] = useState<string | null>(null);

  const [valueMin, setValueMin] = useState("");
  const [valueMax, setValueMax] = useState("");

  const [isEditedCleaning, setIsEditedCleaning] = useState(false);
  const [isEditedSCurve, setIsEditedSCurve] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const [ahsOptions, setAhsOptions] = useState<any[]>([]);
  const [projectOptions, setProjectOptions] = useState<any[]>([]);
  const [employeeOptions, setEmployeeOptions] = useState<any[]>([]);


  const [totalRabAdd, setTotalRabAdd] = useState(0);
  const [totalRabEdit, setTotalRabEdit] = useState(0);


  const fetchProjectList = async () => {
    try {
      const result = await getOfficeProjects({ limit: 10000000 });
      setProjectOptions(result.data); // Simpan data item dari backend
    } catch (error) {
      console.error("Failed to fetch items:", error);
    }
  };


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  function terbilang(nilai) {
    const angka = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas"];

    function convert(n) {
      n = Math.floor(n);
      if (n < 12) return angka[n];
      else if (n < 20) return convert(n - 10) + " Belas";
      else if (n < 100) return convert(Math.floor(n / 10)) + " Puluh " + convert(n % 10);
      else if (n < 200) return "Seratus " + convert(n - 100);
      else if (n < 1000) return convert(Math.floor(n / 100)) + " Ratus " + convert(n % 100);
      else if (n < 2000) return "Seribu " + convert(n - 1000);
      else if (n < 1000000) return convert(Math.floor(n / 1000)) + " Ribu " + convert(n % 1000);
      else if (n < 1000000000) return convert(Math.floor(n / 1000000)) + " Juta " + convert(n % 1000000);
      else if (n < 1000000000000) return convert(Math.floor(n / 1000000000)) + " Miliar " + convert(n % 1000000000);
      else return "Angka terlalu besar";
    }

    return convert(nilai).replace(/\s+/g, " ").trim();
  }


  const showPopupMandatoryError = (detail) => {
    Swal.fire({
      icon: "error",
      title: "Data Belum Lengkap",
      text: detail,
    });
  };

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "officeId", label: "Nama Office" },
    // { value: "readinessStatus", label: "Status Workspace" },
    { value: "workspaceName", label: "Nama Workspace" },
    { value: "floor", label: "Lantai" },
    // { value: "startDate", label: "Start Date" },
    // { value: "endDate", label: "End Date" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "officeId", label: "Nama Office" },
    // { value: "readinessStatus", label: "Status Workspace" },
    { value: "workspaceName", label: "Nama Workspace" },
    { value: "floor", label: "Lantai" },
    { value: "startDate", label: "Start Date" },
    { value: "endDate", label: "End Date" },
  ];

  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    officeId?: string;
    readinessStatus?: string;
    workspaceName?: string;
    floor?: string;
    limit?: number;
    startDateCleaning?: string,
    endDateCleaning?: string,
    offset?: number;
    orderBy?: string;
    order?: string;
  }>({});

  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const fetchWorkspaces = async () => {
    setIsLoading(true);
    try {


      const result = await getWorkspace({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });



      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchProjectList();
    fetchWorkspaces();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);


  useEffect(() => {
    handleApplyFilters();
  }, [officeFilter, workspaceFilter, floorFilter, startDateCleaning, endDateCleaning, periodeFilter]);

  const nullWorkspaceData = {
    officeId: "",
    workspaceName: "",
    workspaceInfo: "",
    floor: "",
    capacity: "",
    readinessStatus: "",
    lastCleaningDate: "",
    amenities: "",
    file: null,
  }

  const [workspaceData, setWorkspaceData] = useState<{
    officeId: string,
    workspaceName: string,
    workspaceInfo: string,
    floor: string,
    capacity: string,
    readinessStatus: string,
    lastCleaningDate: string,
    amenities: string,
    file: File | null;
  }>(nullWorkspaceData);

  const [errors, setErrors] = useState({
    officeId: false,
    workspaceName: false,
    workspaceInfo: false,
    floor: false,
    capacity: false,
    readinessStatus: false,
    lastCleaningDate: false,
    amenities: false,
  });

  const [openEditWorkspaceDialog, setOpenEditWorkspaceDialog] = useState(false);

  const [isEditing, setIsEditing] = useState(false);

  const nullEditWorkspace = {
    id: "",
    officeId: "",
    workspaceName: "",
    workspaceInfo: "",
    floor: "",
    capacity: "",
    readinessStatus: "",
    lastCleaningDate: "",
    amenities: "",
    file: null,
    photo: "",
    previewUrl: "",
  }
  const [editWorkspaceData, setEditWorkspaceData] = useState<{
    id: string,
    officeId: string,
    workspaceName: string,
    workspaceInfo: string,
    floor: string,
    capacity: string,
    readinessStatus: string,
    lastCleaningDate: string,
    amenities: string,
    file: File | null,
    photo: string,
    previewUrl: string,
  }>(nullEditWorkspace);

  const [originalEditWorkspaceData, setOriginalEditWorkspaceData] = useState<{
    id: string,
    officeId: string,
    workspaceName: string,
    workspaceInfo: string,
    floor: string,
    capacity: string,
    readinessStatus: string,
    lastCleaningDate: string,
    amenities: string,
    file: File | null,
    photo: string,
    previewUrl: string,
  }>(nullEditWorkspace);

  const [editErrors, setEditErrors] = useState({
    officeId: false,
    workspaceName: false,
    workspaceInfo: false,
    floor: false,
    capacity: false,
    readinessStatus: false,
    lastCleaningDate: false,
    amenities: false,
  });

  const nullCleaningAdd = {
    workspaceReadinessId: "",
    cleaningInfo: "",
    cleaningDate: "",
    user: "",
    // === CleaningHistory Update fields ===
    floor: "",
    roomTemperature: "",
    lightingStatus: "",
    ceilingStatus: "",
    socketStatus: "",
    doorStatus: "",
    wallStatus: "",
    inspectionPeriod: "",
    inspectionDate: "",
  }
  const [cleaningAdd, setCleaningAdd] = useState<{
    workspaceReadinessId: string;
    cleaningInfo: string;
    cleaningDate: string;
    user: string;
    // === CleaningHistory Update fields ===
    floor: string;
    roomTemperature: string;
    lightingStatus: string;
    ceilingStatus: string;
    socketStatus: string;
    doorStatus: string;
    wallStatus: string;
    inspectionPeriod: string;
    inspectionDate: string;
  }>(nullCleaningAdd);

  const [cleaningData, setCleaningData] = useState<Array<{
    workspaceReadinessId: string;
    cleaningInfo: string;
    cleaningDate: string;
    user: string;
    // === CleaningHistory Update fields ===
    floor: string,
    roomTemperature: string,
    lightingStatus: string,
    ceilingStatus: string,
    socketStatus: string,
    doorStatus: string,
    wallStatus: string,
    inspectionPeriod: string,
    inspectionDate: string,
  }>>([]);

  const nullCleaningEdit = {
    id: null,
    workspaceReadinessId: "",
    cleaningInfo: "",
    cleaningDate: "",
    user: "",
    // === CleaningHistory Update fields ===
    floor: "",
    roomTemperature: "",
    lightingStatus: "",
    ceilingStatus: "",
    socketStatus: "",
    doorStatus: "",
    wallStatus: "",
    inspectionPeriod: "",
    inspectionDate: "",
  }

  const [cleaningEdit, setCleaningEdit] = useState<{
    id: string | null,
    workspaceReadinessId: string,
    cleaningInfo: string,
    cleaningDate: string,
    user: string,
    // === CleaningHistory Update fields ===
    floor: string,
    roomTemperature: string,
    lightingStatus: string,
    ceilingStatus: string,
    socketStatus: string,
    doorStatus: string,
    wallStatus: string,
    inspectionPeriod: string,
    inspectionDate: string,
  }>(nullCleaningEdit);

  const [cleaningDataOnEdit, setCleaningDataOnEdit] = useState<Array<{
    id: string,
    workspaceReadinessId: string,
    cleaningInfo: string,
    cleaningDate: string,
    user: string,
    // === CleaningHistory Update fields ===
    floor: string,
    roomTemperature: string,
    lightingStatus: string,
    ceilingStatus: string,
    socketStatus: string,
    doorStatus: string,
    wallStatus: string,
    inspectionPeriod: string,
    inspectionDate: string,
  }>>([]);

  const [originalCleaningDataOnEdit, setOriginalCleaningDataOnEdit] = useState<Array<{
    id: string,
    workspaceReadinessId: string,
    cleaningInfo: string,
    cleaningDate: string,
    user: string,
    // === CleaningHistory Update fields ===
    floor: string,
    roomTemperature: string,
    lightingStatus: string,
    ceilingStatus: string,
    socketStatus: string,
    doorStatus: string,
    wallStatus: string,
    inspectionPeriod: string,
    inspectionDate: string,
  }>>([]);


  const handleAddCleaningInfo = () => {
    if (!cleaningAdd.inspectionDate || !cleaningAdd.inspectionPeriod) {
      Swal.fire({
        icon: "warning",
        title: "Data Workspace Data belum lengkap",
        text: "Pastikan data Workspace Data sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const today = new Date().toISOString();
    const user = localStorage.getItem("username") || "";

    const newDetail = {
      workspaceReadinessId: "",
      cleaningInfo: cleaningAdd.cleaningInfo,
      cleaningDate: today,
      user: user,
      // === CleaningHistory Update fields ===
      floor: workspaceData.floor,
      roomTemperature: cleaningAdd.roomTemperature,
      lightingStatus: cleaningAdd.lightingStatus,
      ceilingStatus: cleaningAdd.ceilingStatus,
      socketStatus: cleaningAdd.socketStatus,
      doorStatus: cleaningAdd.doorStatus,
      wallStatus: cleaningAdd.wallStatus,
      inspectionPeriod: cleaningAdd.inspectionPeriod,
      inspectionDate: cleaningAdd.inspectionDate,
    };

    const updatedDetails = [...cleaningData, newDetail];
    setCleaningData(updatedDetails);

    setCleaningAdd(nullCleaningAdd); // reset form AHS
  };

  // Handler klik row tabel
  const handleRowAddClick = (row: any, index: any) => {
    setIsEditRow(true);
    setIndexRow(index);
    setCleaningAdd({
      inspectionDate: row.inspectionDate || "",
      inspectionPeriod: row.inspectionPeriod || "",
      roomTemperature: row.roomTemperature || "",
      lightingStatus: row.lightingStatus || "",
      ceilingStatus: row.ceilingStatus || "",
      socketStatus: row.socketStatus || "",
      doorStatus: row.doorStatus || "",
      wallStatus: row.wallStatus || "",
      floor: row.floor || "",
      workspaceReadinessId: row.workspaceReadinessId || "", // opsional kalau mau ikut isi
      cleaningDate: row.cleaningDate || null,
      cleaningInfo: row.cleaningInfo || "",
      user: row.user || "",
    });
  };

  // Handler klik row tabel
  const handleUpdateCleaningInfo = () => {
    if (!cleaningData.cleaningInfo) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan data sudah terisi sebelum menambahkan.",
      });
      return;
    }
    // if (!indexRow) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Index Data Workspace gagal diupdate",
    //     text: "Mohon ulangi kembali",
    //   });
    //   return;
    // }
    // setIsEditedCleaning(true);
    cleaningData[indexRow] = cleaningData;
    setCleaningAdd(nullCleaningAdd);
    setIndexRow(undefined);
    setIsEditRow(false);
  };
  // Handler klik row tabel
  const handleCancelCleaningInfo = () => {
    setCleaningAdd(nullCleaningAdd);
    setIndexRow(undefined);
    setIsEditRow(false);
  };

  const handleAddCleaningInfoOnEdit = () => {
    if (!cleaningEdit.inspectionDate || !cleaningEdit.inspectionPeriod) {
      Swal.fire({
        icon: "warning",
        title: "Data Workspace Data belum lengkap",
        text: "Pastikan data Workspace Data sudah terisi sebelum menambahkan.",
      });
      return;
    }

    const today = new Date().toISOString();
    const user = localStorage.getItem("username") || "";

    const newDetail = {
      id: "",
      workspaceReadinessId: editWorkspaceData.id,
      cleaningInfo: cleaningEdit.cleaningInfo,
      cleaningDate: today,
      user: user,
      // === CleaningHistory Update fields ===
      floor: editWorkspaceData.floor,
      roomTemperature: cleaningEdit.roomTemperature,
      lightingStatus: cleaningEdit.lightingStatus,
      ceilingStatus: cleaningEdit.ceilingStatus,
      socketStatus: cleaningEdit.socketStatus,
      doorStatus: cleaningEdit.doorStatus,
      wallStatus: cleaningEdit.wallStatus,
      inspectionPeriod: cleaningEdit.inspectionPeriod,
      inspectionDate: cleaningEdit.inspectionDate,
    };

    const updatedDetails = [...cleaningDataOnEdit, newDetail];
    setCleaningDataOnEdit(updatedDetails);

    setIsEditedCleaning(true);

    setCleaningEdit(nullCleaningAdd); // reset form AHS
  };

  // Handler klik row tabel
  const handleRowEditClick = (row: any, index: any) => {
    setIsEditRowOnEdit(true);
    setIndexRowOnEdit(index);
    setCleaningEdit({
      inspectionDate: row.inspectionDate || "",
      inspectionPeriod: row.inspectionPeriod || "",
      roomTemperature: row.roomTemperature || "",
      lightingStatus: row.lightingStatus || "",
      ceilingStatus: row.ceilingStatus || "",
      socketStatus: row.socketStatus || "",
      doorStatus: row.doorStatus || "",
      wallStatus: row.wallStatus || "",
      floor: row.floor || "",
      workspaceReadinessId: row.workspaceReadinessId || "", // opsional kalau mau ikut isi
      cleaningDate: row.cleaningDate || null,
      cleaningInfo: row.cleaningInfo || "",
      user: row.user || "",
      id: row.id || null,
    });
  };

  // Handler klik row tabel
  const handleUpdateCleaningInfoOnEdit = () => {
    if (!cleaningEdit.cleaningInfo) {
      Swal.fire({
        icon: "warning",
        title: "Data belum lengkap",
        text: "Pastikan data sudah terisi sebelum menambahkan.",
      });
      return;
    }
    // if (!indexRowOnEdit) {
    //   Swal.fire({
    //     icon: "warning",
    //     title: "Index Data Workspace gagal diupdate",
    //     text: "Mohon ulangi kembali",
    //   });
    //   return;
    // }
    setIsEditedCleaning(true);
    cleaningDataOnEdit[indexRowOnEdit] = cleaningEdit;
    setCleaningEdit(nullCleaningEdit);
    setIndexRowOnEdit(undefined);
    setIsEditRowOnEdit(false);
  };
  // Handler klik row tabel
  const handleCancelCleaningInfoOnEdit = () => {
    setCleaningEdit(nullCleaningEdit);
    setIndexRowOnEdit(undefined);
    setIsEditRowOnEdit(false);
  };

  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setWorkspaceData({ ...workspaceData, file });
  };

  const handleEditFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditWorkspaceData({ ...editWorkspaceData, file });
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setWorkspaceData({ ...workspaceData, [name]: value });
  };

  const handleInputChangeOnEdit = (e) => {
    const { name, value } = e.target;
    setEditWorkspaceData({ ...editWorkspaceData, [name]: value });
  };

  const validateForm = () => {
    let newErrors = {
      officeId: !workspaceData.officeId,
      workspaceName: !workspaceData.workspaceName,
      // grandTotal: !rabData.grandTotal,
    };

    console.log(newErrors)

    setErrors({ ...errors, ...newErrors });
    return !Object.values(newErrors).includes(true);
  };

  const validateEditForm = () => {
    let newErrors = {
      officeId: !editWorkspaceData.officeId,
      workspaceName: !editWorkspaceData.workspaceName,
      floor: !editWorkspaceData.floor,
    };

    setEditErrors({ ...editErrors, ...newErrors });
    return !Object.values(newErrors).includes(true);
  };

  const errorResponse = (title, error) => {
    let errorTitle = "";
    let errorDetails = "";

    // Handle backend error response
    if (error.response?.data) {
      const backendError = error.response.data;

      // Debug log untuk melihat struktur error
      console.log(
        "Backend Error Structure:",
        JSON.stringify(backendError, null, 2)
      );

      // Main error message
      errorTitle = backendError.error || errorTitle;

      // Handle all possible email validation error formats - PERBAIKAN UTAMA
      const isEmailValidationError =
        // Case 1: Error in details (Sequelize style)
        (backendError.details &&
          /validation isEmail on (email|projectEmail)/i.test(
            backendError.details
          )) ||
        // Case 2: Error in errors array (Sequelize validation errors)
        (backendError.errors &&
          backendError.errors.some(
            (err: any) =>
              (err.path === "email" || err.path === "projectEmail") &&
              err.validatorKey === "isEmail"
          )) ||
        // Case 3: Error in message (generic API responses)
        (backendError.message &&
          /email.*invalid/i.test(backendError.message));

      if (isEmailValidationError) {
        errorTitle = "Format Email Tidak Valid";
        errorDetails =
          "• Format email tidak valid (contoh: nama@perusahaan.com)";
      }
      // Only use details if not an email error
      else if (backendError.details) {
        errorDetails = backendError.details;
      }

      // Handle validation errors (improved processing)
      if (backendError.errors) {
        const validationMessages = backendError.errors
          .map((err: any) => {
            // Handle both array and object error formats
            const errorObj = Array.isArray(err) ? err[0] : err;

            // Skip email errors since we already handled them
            if (
              (errorObj.path === "email" ||
                errorObj.path === "projectEmail") &&
              errorObj.validatorKey === "isEmail"
            ) {
              return null;
            }
            return `• ${errorObj.message || "Terjadi kesalahan validasi"}`;
          })
          .filter(Boolean) // Remove null entries
          .join("\n");

        if (validationMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${validationMessages}`
            : validationMessages;
        }
      }

      // Handle duplicate fields (improved formatting)
      if (backendError.duplicates) {
        const duplicateMessages = backendError.duplicates
          .map((dup: any) => `• ${dup.field}: ${dup.value} sudah terdaftar`)
          .join("\n");

        if (duplicateMessages) {
          errorDetails = errorDetails
            ? `${errorDetails}\n${duplicateMessages}`
            : duplicateMessages;
        }
      }
    }
    // Handle network or other errors
    else {
      errorDetails =
        error.message || "Terjadi kesalahan jaringan atau server";
    }

    // Show error in Swal (improved formatting)
    Swal.fire({
      icon: "error",
      title: title,
      html: `
                <div style="text-align: left;">
                  <p style="font-weight: bold; margin-bottom: 10px; color: #d32f2f;">
                    ${errorTitle}
                  </p>
                  ${errorDetails
          ? `<div style="
                          color: #5f2120;
                          background: #fdecea;
                          padding: 12px;
                          border-radius: 4px;
                          font-size: 0.9em;
                          border-left: 4px solid #d32f2f;
                          line-height: 1.5;
                        ">
                          ${errorDetails.replace(/\n/g, "<br>")}
                        </div>`
          : ""
        }
                </div>
              `,
      confirmButtonColor: "#0F62FE",
      width: "600px",
    });
  }


  const handleSubmitAddWorkspace = async () => {

    if (!validateForm()) {
      return showPopupMandatoryError("Lengkapi data yang wajib diisi.");
    }

    try {
      console.log(workspaceData);
      workspaceData.lastCleaningDate = await new Date().toISOString();
      workspaceData.readinessStatus = 'Ready';


      // Step 1: Create Workspace
      const newWorkspace = await createWorkspace(workspaceData);

      if (!newWorkspace?.id) throw new Error("Gagal membuat Workspace");

      const updatedWorkspaceDetails = cleaningData.map((detail) => ({
        ...detail,
        workspaceReadinessId: newWorkspace.id,
        cleaningInfo: "OK",
      }));

      const failedDetails: string[] = [];

      // Step 2: Loop create RabDetail dan SCurve
      for (const detail of updatedWorkspaceDetails) {
        try {
          const newCleaning = await createCleaning(detail);

          if (!newCleaning?.id) throw new Error("Gagal simpan workspace data");


        } catch (err) {
          console.error("Gagal menyimpan Workspace Data:", detail, err);
          failedDetails.push(detail.cleaningInfo);
        }
      }

      // Show error jika ada yang gagal
      if (failedDetails.length) {
        const errorText = [
          failedDetails.length && `Workspace Data gagal: ${failedDetails.join(", ")}`
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "Workspace Data berhasil ditambahkan",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenAddWorkspaceDialog(false);
      setCleaningData([]);

      setWorkspaceData(nullWorkspaceData);
      await fetchWorkspaces();
    } catch (error: any) {
      await errorResponse("Gagal membuat Workspace", error);
    }
  };

  const handleSubmitEditWorkspace = async () => {

    if (!validateEditForm()) {
      showPopupMandatoryError("Lengkapi data yang wajib diisi.");
      return;
    }

    try {
      console.log(editWorkspaceData);

      // Step 1: Create Workspace
      const wsData = await editWorkspace(editWorkspaceData);

      // Jika ada gambar baru, upload
      if (editWorkspaceData.file) {
        await uploadWorkspacePhoto(editWorkspaceData.id, editWorkspaceData.file);
      }


      if (!wsData?.id) throw new Error("Gagal mengupdate Workspace");
      console.log("editWorkspace", wsData);

      const failedDetails: string[] = [];

      if (isEditedCleaning) {
        await originalCleaningDataOnEdit.map(async (detail) => (await deleteCleaning(detail.id)));

        const updatedCleanings = await cleaningDataOnEdit.map((detail) => ({
          ...detail,
          workspaceReadinessId: wsData.id,
          cleaningInfo: "OK",
          id: undefined,
        }));

        // Step 2: Loop create Cleaning dan SCurve
        for (const detail of updatedCleanings) {
          try {
            const newCleaning = await createCleaning(detail);

            if (!newCleaning?.id) throw new Error("Gagal simpan workspace data");


          } catch (err) {
            console.error("Gagal menyimpan Workspace Data:", detail, err);
            failedDetails.push(detail.cleaningInfo);
          }
        }
      }


      // Show error jika ada yang gagal
      if (failedDetails.length) {
        const errorText = [
          failedDetails.length && `Workspace Data gagal: ${failedDetails.join(", ")}`,
        ]
          .filter(Boolean)
          .join("<br>");

        await Swal.fire({
          icon: "error",
          title: "Sebagian data gagal disimpan",
          html: errorText,
        });
      } else {
        // Show success jika semua berhasil
        await Swal.fire({
          icon: "success",
          title: "Workspace Data berhasil diedit",
          confirmButtonColor: "#0F62FE",
        });
      }

      // Reset dan tutup dialog
      setOpenEditWorkspaceDialog(false);
      setCleaningDataOnEdit([]);
      setEditWorkspaceData(nullEditWorkspace);
      setIsEditedCleaning(false);
      await fetchWorkspaces();
    } catch (error: any) {
      await errorResponse("Gagal mengupdate Workspace", error);
    }
  };

  const handleOpenEditWorkspace = async (ws) => {

    const userJobTitle = employeeOptions.find(emp => emp.email === localStorage.getItem("email"))?.jobTitle || "";
    const isManager = userJobTitle.toLowerCase().includes("manager");

    setIsApprover(isManager);


    const cleaning = await getCleaning({ limit: 1000000, workspaceReadinessId: ws.id });
    // const rabDetailWithAHS = rabDetail.data.map(rab => {
    //   // const ahsDetail = ahsOptions.find((ahs) => ahs.id === rab.ahsId);
    //   const ahsDetail = rab.ahs;
    //   rab.category = ahsDetail.category;
    //   rab.hargaSatuan = ahsDetail.totalAHS;
    //   rab.satuanAHS = ahsDetail.satuanAHS;
    //   rab.namaAHS = ahsDetail.namaAHS;
    //   return rab;
    // })


    setIsEditedCleaning(false);
    setIsEditedSCurve(false);



    await setEditWorkspaceData({
      ...ws,
      file: null,
    });
    await console.log(ws, editWorkspaceData);


    await setOriginalEditWorkspaceData(ws); // Simpan nilai asli untuk tombol cancel
    await setCleaningDataOnEdit(cleaning.data);
    await setOriginalCleaningDataOnEdit(cleaning.data);
    await setIsEditing(false); // Kunci form sampai tombol edit diklik
    await setOpenEditWorkspaceDialog(true);

  };

  const handleDeleteCleaning = (indexToRemove: number) => {
    const cleaningIdToRemove = cleaningData[indexToRemove].user;

    // Hapus baris dari rabDetailAdd
    const updatedClaning = cleaningData.filter((_, idx) => idx !== indexToRemove);
    setCleaningData(updatedClaning);


    // setIsEditedCleaning(true);
  };

  const handleDeleteCleaningOnEdit = (indexToRemove: number) => {
    setIsEditRowOnEdit(false);
    const ahsIdToRemove = cleaningDataOnEdit[indexToRemove].user;

    // Hapus baris dari cleaningData
    const updatedRabDetails = cleaningDataOnEdit.filter((_, idx) => idx !== indexToRemove);
    setCleaningDataOnEdit(updatedRabDetails);


    setIsEditedCleaning(true);
  };


  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => {
        const deletedRab = await deleteWorkspace(id);

      }));

      Swal.fire({
        icon: "success",
        title: "Workspace berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchWorkspaces(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleCancelEditWorkspace = () => {
    console.log("data", editWorkspaceData, "ori", originalEditWorkspaceData);
    setEditWorkspaceData({ ...originalEditWorkspaceData }); // Kembalikan nilai asli
    setCleaningEdit(nullCleaningEdit);
    console.log("data", cleaningDataOnEdit, "ori", originalCleaningDataOnEdit);
    setCleaningDataOnEdit({ ...originalCleaningDataOnEdit });
    setIsEditing(false); // Kunci kembali form
    // setOpenEditWorkspaceDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "id", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
    const name = filters[index].field;
    if (name === "startDate") { setStartDateS(null); setEndDateS(null); }
    if (name === "endDate") { setStartDateE(null); setEndDateE(null); }
    if (name === "valueEstimation") { setValueMin(""); setValueMax(""); }
    console.log(filters, startDateS, endDateS)
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `WorkspaceSearchParams`
      const searchParams: WorkspaceSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      if (officeFilter && officeFilter != "") {
        searchParams["officeId"] = officeFilter;
      }
      if (workspaceFilter && workspaceFilter != "") {
        searchParams["workspaceName"] = workspaceFilter;
      }
      if (floorFilter && floorFilter != "") {
        searchParams["floor"] = floorFilter;
      }
      if (startDateCleaning && startDateCleaning != "") {
        searchParams["inspectionDateFrom"] = startDateCleaning;
      }
      if (endDateCleaning && endDateCleaning != "") {
        searchParams["inspectionDateTo"] = endDateCleaning;
      }
      if (periodeFilter && periodeFilter != "") {
        searchParams["inspectionPeriod"] = periodeFilter;
      }

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getRab(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
    setStartDateS(null);
    setEndDateS(null);
    setStartDateE(null);
    setEndDateE(null);
    setValueMin("");
    setValueMax("");
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getRab({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Rab");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Rabs_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export rab data',
      });
    }
  };

  const getExportData = async () => {
    const allWorkspaces = await getWorkspace({
      ...filterParams,
      limit: 10000000,
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allWorkspaces.data.map((row, index) => ({
      'No': index + 1,
      'Office Location': row.officeProject?.office?.officeName || '',
      'Workspace Name': row.workspaceName || '',
      'Floor': row.floor || '',
      'Capacity': row.capacity || '',
      'Workspace Info': row.workspaceInfo || '',
      'Cleaning Activity': row.lastCleaningDate || '',
    }));
  };

  const exportWorkspaceToPDF = async () => {

    const result = await getWorkspace({
      ...filterParams,
      limit: 1000000,
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });
    const rows = await result.data;
    const norm = (v) => (v || "").toString().trim().toLowerCase();
    const mark = (v) => (v ? "✓" : "");
    // const mark = (v) => (v ? "V" : "");

    const tgl = (iso) => {
      if (!iso) return "-";
      const d = new Date(iso);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yy = d.getFullYear();
      return `${dd}-${mm}-${yy}`;
    };

    const arr = await (rows ?? []).flatMap(r =>
      (r.cleaningHistories ?? []).map(c => ({
        floor: r.floor ?? "-",
        inspectionDate: tgl(c.inspectionDate) ?? "-",
        inspectionPeriod: c.inspectionPeriod ?? "-",
        roomTemperature: c.roomTemperature ?? "-",

        lampu_normal: norm(c.lightingStatus) === "baik",
        lampu_tidak: norm(c.lightingStatus) === "tidak baik",

        stop_baik: norm(c.socketStatus) === "baik",
        stop_tidak: norm(c.socketStatus) === "tidak baik",

        plafon_baik: norm(c.ceilingStatus) === "baik",
        plafon_tidak: norm(c.ceilingStatus) === "tidak baik",

        dinding_baik: norm(c.wallStatus) === "baik",
        dinding_tidak: norm(c.wallStatus) === "tidak baik",

        pintu_baik: norm(c.doorStatus) === "baik",
        pintu_tidak: norm(c.doorStatus) === "tidak baik",

        cleaningInfo: c.cleaningInfo || ""
      }))
    );

    console.log(rows, arr);
    try {
      const doc = new jsPDF("l", "pt", "a4"); // landscape biar lega
      const pageWidth = doc.internal.pageSize.getWidth();   // ~841.89 pt
      const pageHeight = doc.internal.pageSize.getHeight();  // ~595.28 pt
      const margin = 20;                                     // kiri/kanan/atas
      let cursorY = margin;                                  // penanda Y berjalan


      // 1. Add header image
      try {
        const headerImageUrl = `${window.location.origin}/img/KOP_SPP_wide.jpg`;
        const resp = await fetch(headerImageUrl);
        if (resp.ok) {
          const blob = await resp.blob();

          // Baca sebagai base64 dan ambil ukuran asli gambar
          const base64Image = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });

          // Ambil natural width/height untuk jaga-jaga (kalau beda dari 1600x140)
          const dims = await new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve({ w: img.naturalWidth, h: img.naturalHeight });
            img.src = base64Image;
          });

          const { w: imgW = 1600, h: imgH = 140 } = dims;

          // Ruang yang dipakai header = full width minus margin
          const availWidth = pageWidth - 2 * margin; // lebar konten
          const scale = availWidth / imgW;
          const drawW = availWidth;
          const drawH = imgH * scale;               // jaga rasio 1600:140

          // Gambar di posisi x = margin, y = cursorY
          doc.addImage(
            base64Image,
            "JPEG",            // pakai "PNG" kalau filenya PNG
            margin,            // x
            cursorY,           // y
            drawW,             // width penuh
            drawH              // height sesuai rasio
          );

          cursorY += drawH;    // lanjutkan konten setelah header
        }
      } catch (e) {
        console.error("Failed to load header image:", e);
      }


      // 2) GARIS PEMBATAS (full width)
      cursorY += 10;
      doc.setDrawColor(0);
      doc.setLineWidth(0.7);
      doc.line(margin, cursorY, pageWidth - margin, cursorY);
      cursorY += 18;

      // 3) JUDUL (center & auto wrap)
      doc.setFontSize(16);
      const centerX = pageWidth / 2;
      const titleMaxWidth = pageWidth - 2 * margin;

      let titleText = "CHECKLIST HARIAN RUANG KERJA";
      let wrapped = doc.splitTextToSize(titleText, titleMaxWidth);
      doc.text(wrapped, centerX, cursorY, { align: "center" });
      cursorY += 18;

      titleText = `${projectOptions.find(p => p.id == officeFilter).office.officeName || ""}`;
      wrapped = doc.splitTextToSize(titleText, titleMaxWidth);
      doc.text(wrapped, centerX, cursorY, { align: "center" });
      cursorY += 20;

      // 4) INFO RINGKAS (rata kiri, mengikuti margin)
      doc.setFontSize(10);
      doc.text(
        `TANGGAL : ${startDateCleaning || "-"} - ${endDateCleaning || "-"}`,
        margin,
        cursorY
      );
      const semua = "Semua Periode"
      doc.text(`PERIODE : ${periodeFilter != '' ? periode[Number(periodeFilter) - 1] : semua || "-"}`, margin, cursorY + 14);
      cursorY += 22;
      // doc.text("RAB Details", 15, rabDetailsTitleY);

      autoTable(doc, {
        head: [
          [
            { content: "NO.", rowSpan: 2 },
            { content: "LANTAI", rowSpan: 2 },
            { content: "TANGGAL", rowSpan: 2 },
            { content: "PERIODE", rowSpan: 2 },
            { content: "SUHU", rowSpan: 2 },

            { content: "LAMPU", colSpan: 2 },
            { content: "STOP KONTAK", colSpan: 2 },
            { content: "PLAFON", colSpan: 2 },
            { content: "DINDING", colSpan: 2 },
            { content: "PINTU", colSpan: 2 },

            { content: "KET", rowSpan: 2 }
          ],
          [
            "NORMAL", "TIDAK",
            "BAIK", "TIDAK",
            "BAIK", "TIDAK",
            "BAIK", "TIDAK",
            "BAIK", "TIDAK"
          ]
        ],
        // ===== BODY =====
        body: arr.map((r, i) => [
          `${i + 1}`,
          r.floor,
          r.inspectionDate,
          r.inspectionPeriod,
          r.roomTemperature,

          // mark(r.lampu_normal), mark(r.lampu_tidak),
          // mark(r.stop_baik), mark(r.stop_tidak),
          // mark(r.plafon_baik), mark(r.plafon_tidak),
          // mark(r.dinding_baik), mark(r.dinding_tidak),
          // mark(r.pintu_baik), mark(r.pintu_tidak),
          r.lampu_normal, r.lampu_tidak,
          r.stop_baik, r.stop_tidak,
          r.plafon_baik, r.plafon_tidak,
          r.dinding_baik, r.dinding_tidak,
          r.pintu_baik, r.pintu_tidak,

          r.cleaningInfo
        ]),

        // lebar kolom biar proporsional
        columnStyles: {
          0: { cellWidth: 34 },          // NO.
          1: { cellWidth: 40, halign: "left" }, // LANTAI (kiri supaya multi-line rapi)
          2: { cellWidth: 60 },
          3: { cellWidth: 70 },
          4: { cellWidth: 50 },
          5: { cellWidth: 50 }, 6: { cellWidth: 50 },
          7: { cellWidth: 50 }, 8: { cellWidth: 50 },
          9: { cellWidth: 50 }, 10: { cellWidth: 50 },
          11: { cellWidth: 50 }, 12: { cellWidth: 50 },
          13: { cellWidth: 50 }, 14: { cellWidth: 50 },
          15: { cellWidth: 50 }          // KET
        },

        startY: cursorY + 5,
        margin: { left: 15 },
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 10,
          halign: "center",
          valign: "middle",
        },
        styles: {
          cellPadding: 2,
          fontSize: 10,
          halign: "center",
          valign: "middle",
        },
        didParseCell: (hook) => {
          // kosongkan teks untuk kolom boolean, biar digambar manual
          if (hook.section === "body" && hook.column.index >= 5 && hook.column.index <= 14) {
            hook.cell.text = [];
            hook.cell.styles.halign = "center";
          }
        },

        didDrawCell: (hook) => {
          if (hook.section === "body" && hook.column.index >= 5 && hook.column.index <= 14) {
            const val = hook.cell.raw;         // true / false
            const { x, y, width, height } = hook.cell;
            const cx = x + width / 2;
            const cy = y + height / 2;
            const r = Math.min(width, height) * 0.22;

            doc.setDrawColor(30, 50, 70);
            // doc.setLineWidth(1.1);
            // doc.circle(cx, cy, r, "S");        // lingkaran

            // console.log(val)

            if (val === true) {                // ceklis jika "Baik" / "Normal" kolom bersangkutan
              doc.setLineWidth(1.6);
              doc.line(cx - r * 0.6, cy, cx - r * 0.15, cy + r * 0.55);
              doc.line(cx - r * 0.15, cy + r * 0.55, cx + r * 0.7, cy - r * 0.5);
            }
          }
          // LANTAI rata kiri
          if (hook.section === "body" && hook.column.index === 1) {
            hook.cell.styles.halign = "left";
          }
        },
      });

      const user = employeeOptions.find(emp => emp.email === localStorage.getItem("email"))?.name || "";




      // ===== SUMMARY SECTION =====
      const summaryStartY = (doc as any).lastAutoTable.finalY + 10;

      // Calculate column positions
      const labelCol = 130;  // Right-aligned labels
      const valueCol = 180;  // Right-aligned values

      // Amount in words
      doc.setFontSize(9);
      // const amountText = `Terbilang: ${terbilang(Math.round(totalRabEdit * 1.11))} Rupiah`;
      // doc.text(amountText, 15, summaryStartY, { maxWidth: 180 });


      // Approver Footer Section
      const footerStartY = summaryStartY + 12;
      // 0) Buat formatter: Hari, dd MMMM yyyy (timezone Jakarta)
      const formattedDate = new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
        timeZone: "Asia/Jakarta",
      });

      // 1) Tulis tanggal
      const dateY = footerStartY + 10;
      doc.setFontSize(10);
      doc.text(`Jakarta, ${formattedDate}`, 15, dateY);

      // 2) Tabel tanda tangan di bawahnya
      autoTable(doc, {
        head: [[{ content: "MENGETAHUI" }, { content: "DIBUAT OLEH" }]],
        body: [[{ content: " " }, { content: " " }]],
        foot: [[{ content: "AGENG PRASETIONO" }, { content: user.toString().toUpperCase() }]],
        startY: dateY + 24,
        margin: { left: 15, right: 15 },
        headStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 10,
          halign: "center",
          valign: "middle",
        },
        bodyStyles: { minCellHeight: 60, },
        footStyles: {
          fillColor: [100, 100, 100],
          textColor: 255,
          fontStyle: "bold",
          fontSize: 10,
          halign: "center",
          valign: "middle",
        },
        styles: {
          cellPadding: 2,
          fontSize: 10,
          halign: "center",
          valign: "middle",
          // minCellHeight: 200,
        },
      });

      // Footer
      // doc.setFontSize(8);
      // doc.setTextColor(100);
      // doc.text("Generated by RAB System", 105, 285, { align: "center" });
      // doc.text(new Date().toLocaleString(), 105, 290, { align: "center" });

      // 3. Save PDF
      const date = new Date().toISOString().slice(0, 10);
      doc.save(`Checklist_${projectOptions.find(p => p.id == officeFilter).office.officeName || "new"}_${date}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate PDF document",
      });
    }
  };

  const exportWorkspaceDataToExcel = async () => {
    try {
      // Prepare data for Excel export
      // const project = projectOptions.find(pro => pro.id === editWorkspaceData.buildingLocationId) || {};
      // console.log(project);

      // 1. Create workbook
      const wb = XLSX.utils.book_new();

      // 3. Create Workspace Details sheet
      const rabDetailsHeader = [
        "No",
        "Workspace Name",
        "Floor",
        "Date",
        "Periode",
        "Suhu Ruangan",
        "Lampu Penerangan",
        "Stop Kontak",
        "Plafon",
        "Dinding",
        "Pintu",
      ];

      const rabDetailsData = cleaningDataOnEdit.filter((row) => {
        if (!startDateE && !endDateE) return true; // tidak ada filter

        const inspectionDate = dayjs(row.inspectionDate);
        const start = startDateE ? dayjs(startDateE) : null;
        const end = endDateE ? dayjs(endDateE) : null;

        if (start && end) {
          return inspectionDate.isSameOrAfter(start) && inspectionDate.isSameOrBefore(end);
        }
        if (start) {
          return inspectionDate.isSameOrAfter(start);
        }
        if (end) {
          return inspectionDate.isSameOrBefore(end);
        }
        return true;
      }).map((item, index) => [
        index + 1,
        editWorkspaceData.workspaceName,
        editWorkspaceData.floor,
        dayjs(item.inspectionDate).format("DD-MM-YYYY"),
        item.inspectionPeriod,
        item.roomTemperature,
        item.lightingStatus,
        item.socketStatus,
        item.ceilingStatus,
        item.wallStatus,
        item.doorStatus,
      ]);

      const rabDetailsWs = XLSX.utils.aoa_to_sheet([
        [editWorkspaceData.workspaceName || ''],
        [],
        rabDetailsHeader,
        ...rabDetailsData,
        [],
        [],

      ]);

      // Lebar kolom
      rabDetailsWs["!cols"] = [
        { wch: 5 },  // No
        { wch: 25 }, // WorkspaceName
        { wch: 5 }, // Floor
        { wch: 10 }, // Date
        { wch: 10 }, // Period
        { wch: 10 }, // Suhu
        { wch: 10 }, // Lampu
        { wch: 10 }, // Stop Kontak
        { wch: 10 }, // Plafon
        { wch: 10 }, // Dinding
        { wch: 10 }, // Pintu
      ];

      rabDetailsWs["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } }, // Merge Workspace DETAILS title
        { s: { r: rabDetailsData.length + 3, c: 0 }, e: { r: rabDetailsData.length + 3, c: 6 } }, // Merge amount in words
        { s: { r: rabDetailsData.length + 4, c: 0 }, e: { r: rabDetailsData.length + 4, c: 6 } } // Merge amount in words value
      ];

      // 5. Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, rabDetailsWs, "Workspace Data");

      // 6. Generate and download Excel file
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Workspace_Data_${editWorkspaceData.workspaceName || "export"}_${date}.xlsx`);

    } catch (error) {
      console.error("Error exporting to Excel:", error);
      Swal.fire({
        icon: "error",
        title: "Export Failed",
        text: "Failed to generate Excel file",
      });
    }
  };

  return (
    isLoading ? <LoadingOverlay /> :
      <Box sx={{ padding: 3 }}>
        {/* Header & Tabs */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
          <Typography variant="h6" fontWeight="bold">
            Workspace List
          </Typography>
        </Box>

        {/* Toolbar */}
        <Box className="toolbar">
          {/* Left Controls */}
          <Box className="leftControls">
            <Typography>Show</Typography>
            <Select value={rowsPerPage} onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1); // reset ke halaman 1 saat ganti limit
            }} size="small">
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>

            {/* Search Button & Input */}
            <Button
              variant="contained"
              startIcon={<Search />}
              onClick={() => setShowSearch((prev) => !prev)}
              className="searchButton"
            >
              Search
            </Button>
            {showSearch && (
              <TextField
                variant="outlined"
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={async (e) => {
                  await setSearchQuery(e.target.value);
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
                autoFocus
                className="searchInput"
              />
            )}

            {/* Menampilkan Error */}
            {error && <p style={{ color: "red" }}>{error}</p>}
          </Box>


          {/* Right Controls */}
          <Box className="rightControls">
            <Button
              startIcon={<Delete />}
              variant="text"
              onClick={() => {
                const selectedData = rows.filter((row) => selectedRows.includes(row.rabid));
                setItemsToDelete(selectedData);
                setOpenDeleteDialog(true);
              }}
              disabled={selectedRows.length === 0}
            >
              Delete
            </Button>
            {/* Filter Button */}
            {/* <Button
              startIcon={<FilterList />}
              variant="text"
              onClick={() => setOpenFilterDialog(true)}
            >
              Filters
            </Button> */}
            <Button startIcon={<Add />} variant="contained" className="addItemDetailsButton" onClick={() => { setOpenAddWorkspaceDialog(true) }}>
              Add New Workspace
            </Button>
          </Box>
        </Box>
        <Box className="toolbar">
          <Box className="leftControls">
            <Typography>Filter</Typography>
          </Box>
          <Box className="leftControls">
            <Button
              startIcon={<FilterList />}
              variant="text"
              onClick={() => {
                setOfficeFilter("");
                setFloorFilter("");
                setWorkspaceFilter("");
                setStartDateCleaning("");
                setEndDateCleaning("");
                setPeriodeFilter("");
              }}
            >
              Reset Filters
            </Button>
            <Button startIcon={<Download />} variant="contained" disabled={(officeFilter == '')} className="exportButton" onClick={() => exportWorkspaceToPDF()}>
              Export
            </Button>
          </Box>
        </Box>

        <Box display="flex" gap={1}>
            <Box display="flex" gap={1}>
              {/* <Typography>Filter</Typography> */}
              {/* <TextField
              select
              label="Office Project"
              variant="outlined"
              size="small"
              value={officeFilter}
              onChange={(e) => {
                setOfficeFilter(e.target.value);
                if (e.target.value == '') {
                  setFloorFilter("");
                  setWorkspaceFilter("");
                  setStartDateCleaning("");
                  setEndDateCleaning("");
                  setPeriodeFilter("");
                }
              }
              }
              sx={{ mt: 0, minWidth: 160 }}
            >
              <MenuItem value="">
                Select Office
              </MenuItem>
              {projectOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.office.officeName}
                </MenuItem>
              ))}
            </TextField> */}
              <Autocomplete
                fullWidth
                options={projectOptions} sx={{ mt: 0, minWidth: 160 }} size="small"
                getOptionLabel={(option) => option.office.officeName || ""}
                value={projectOptions.find(opt => opt.id === officeFilter) || null}
                onChange={(event, newValue) => {
                  setOfficeFilter(newValue.id);
                  if (!newValue) {
                    setFloorFilter("");
                    setWorkspaceFilter("");
                    setStartDateCleaning("");
                    setEndDateCleaning("");
                    setPeriodeFilter("");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project Name" name="projectName"
                    placeholder="Enter project name"
                    fullWidth
                  // margin="dense"
                  />
                )}
              />
              <TextField
                fullWidth
                label="Workspace Name"
                variant="outlined"
                size="small"
                value={workspaceFilter}
                onChange={(e) => {
                  setWorkspaceFilter(e.target.value);
                }
                }
                disabled={(officeFilter == '')}
                sx={{ mt: 0 }}
              />
              <TextField
                fullWidth
                label="Floor"
                variant="outlined"
                size="small"
                type="number"
                value={floorFilter}
                onChange={(e) => {
                  setFloorFilter(e.target.value);
                }
                }
                disabled={(officeFilter == '')}
                sx={{ mt: 0 }}
              />
            </Box>
            {/* Date Filters */}
            <Box display="flex" gap={1}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  // fullWidth
                  label="Date From"
                  format="YYYY-MM-DD"
                  value={startDateCleaning ? dayjs(startDateCleaning) : null}
                  onChange={(newValue) =>
                    setStartDateCleaning(newValue ? newValue.format("YYYY-MM-DD") : null)
                  }
                  disabled={(officeFilter == '')}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      // sx: { minWidth: 150 },
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDatePicker
                  // fullWidth
                  label="Date To"
                  format="YYYY-MM-DD"
                  value={endDateCleaning ? dayjs(endDateCleaning) : null}
                  onChange={(newValue) =>
                    setEndDateCleaning(newValue ? newValue.format("YYYY-MM-DD") : null)
                  }
                  disabled={(officeFilter == '')}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      // sx: { minWidth: 150 },
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
              <TextField
                select
                fullWidth
                // margin="normal"
                size="small"
                label="Periode Pemeriksaan"
                placeholder="Periode Pemeriksaan"
                name="periodeFilter"
                value={periodeFilter || ""}
                onChange={(e) =>
                  setPeriodeFilter(e.target.value)
                }
                disabled={(officeFilter == '')}
              // sx={{ minWidth: 150 }}
              >
                <MenuItem value="">
                  Semua Periode
                </MenuItem>
                <MenuItem value="1">Pukul 06.00 s/d 08.00 WIB</MenuItem>
                <MenuItem value="2">Pukul 11.00 s/d 13.00 WIB</MenuItem>
                <MenuItem value="3">Pukul 16.00 s/d 18.00 WIB</MenuItem>
              </TextField>
            </Box>



        </Box>


        {/* Delete Button & Subtitle */}

        <Box className="deleteContainer">
          <Typography variant="body2" className="detailsSubtitle">
            Details List Of All Workspace
          </Typography>
        </Box>


        {/* Table */}
        <TableContainer component={Paper} className="tableContainer">
          <Table className="table">
            <TableHead className="tableHead">
              <TableRow>
                {/* Checkbox header */}
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                    checked={selectedRows.length === rows.length}
                    onChange={() =>
                      setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                    }
                  />
                </TableCell>
                <TableCell>No</TableCell>
                {/* Header dengan sorting */}
                <TableCell className="tableCell" onClick={() => handleSort("officeProject.office.officeName")} style={{ cursor: "pointer" }}>
                  <strong>Office Location</strong>
                  {sortConfig.orderBy === "officeProject.office.officeName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("workspaceName")} style={{ cursor: "pointer" }}>
                  <strong>Workspace Name</strong>
                  {sortConfig.orderBy === "workspaceName" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("floor")} style={{ cursor: "pointer" }}>
                  <strong>Floor</strong>
                  {sortConfig.orderBy === "floor" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("capacity")} style={{ cursor: "pointer" }}>
                  <strong>Capacity</strong>
                  {sortConfig.orderBy === "capacity" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                <TableCell className="tableCell" onClick={() => handleSort("workspaceInfo")} style={{ cursor: "pointer" }}>
                  <strong>Workspace Info</strong>
                  {sortConfig.orderBy === "workspaceInfo" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell>
                {/* <TableCell className="tableCell" onClick={() => handleSort("lastCleaningDate")} style={{ cursor: "pointer" }}>
                  <strong>Cleaning Activity</strong>
                  {sortConfig.orderBy === "lastCleaningDate" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell> */}
                {/* <TableCell className="tableCell" onClick={() => handleSort("amenities")} style={{ cursor: "pointer" }}>
                  <strong>Amenities</strong>
                  {sortConfig.orderBy === "amenities" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
                </TableCell> */}
                <TableCell className="tableCell">
                </TableCell> {/* Kolom untuk aksi */}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                  {/* Checkbox */}
                  <TableCell padding="checkbox" className="tableCell">
                    <Checkbox
                      checked={selectedRows.includes(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                  <TableCell>
                    {/* Nomor urut disesuaikan dengan pagination */}
                    {offset + index + 1}
                  </TableCell>
                  {/* Data */}
                  <TableCell className="tableCell" title={row.officeProject.office.officeName}><strong>{row.officeProject.office.officeName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.workspaceName}><strong>{row.workspaceName}</strong></TableCell>
                  <TableCell className="tableCell" title={row.floor}><strong>{row.floor}</strong></TableCell>
                  <TableCell className="tableCell" title={row.capacity}><strong>{row.capacity}</strong></TableCell>
                  <TableCell className="tableCell" title={row.workspaceInfo}><strong>{row.workspaceInfo}</strong></TableCell>
                  {/* <TableCell className="tableCell" title={row.lastCleaningDate}>{row.lastCleaningDate}</TableCell> */}
                  {/* <TableCell className="tableCell" title={row.amenities}>{row.amenities}</TableCell> */}
                  {/* Ikon More Options */}
                  <TableCell className="tableCell">
                    <IconButton onClick={() => { handleOpenEditWorkspace(row) }}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>


        {/* Pagination */}
        <Box
          className="paginationContainer"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: "16px 0",
          }}
        >
          {/* Info jumlah data */}
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {`Showing ${offset + 1} to ${Math.min(
              offset + rowsPerPage,
              totalItems
            )} of ${totalItems} entries`}
          </Typography>

          {/* Komponen Pagination */}
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(e, page) => setCurrentPage(page)}
            className="pagination"
            showFirstButton
            showLastButton
            renderItem={(item) => (
              <PaginationItem
                {...item}
                components={{ first: FirstPage, last: LastPage }}
              />
            )}
          />
        </Box>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
          <DialogTitle>Delete Rows?</DialogTitle>
          <DialogContent>
            <DialogContentText>Are you sure you want to delete the selected rows?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
            <Button onClick={handleDeleteRows} color="error">Delete</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Add New Workspace */}
        <Dialog open={openAddWorkspaceDialog} onClose={() => setOpenAddWorkspaceDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Add New Workspace</Typography>
              <IconButton onClick={() => setOpenAddWorkspaceDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Autocomplete
                fullWidth
                options={projectOptions}
                getOptionLabel={(option) => option.office.officeName || ""}
                value={projectOptions.find(opt => opt.id === workspaceData.officeId) || null}
                onChange={(event, newValue) => {
                  handleInputChange({
                    target: {
                      name: "officeId",
                      value: newValue ? newValue.id : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Project Name" name="projectName"
                    placeholder="Enter project name"
                    fullWidth
                    margin="normal"
                    error={!workspaceData.officeId}
                    helperText={!workspaceData.officeId ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                fullWidth label="Workspace Name" name="workspaceName" margin="normal"
                placeholder="Workspace Name" value={workspaceData.workspaceName}
                onChange={handleInputChange}
                error={!workspaceData.workspaceName}
                helperText={!workspaceData.workspaceName ? "Mandatory Field" : ""}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth label="Workspace Info" name="workspaceInfo" margin="normal"
                placeholder="Workspace Info" value={workspaceData.workspaceInfo}
                onChange={handleInputChange}
                error={!workspaceData.workspaceInfo}
                helperText={!workspaceData.workspaceInfo ? "Mandatory Field" : ""}
              />
            </Box>
            {/* <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth label="Amenities" name="amenities" margin="normal"
                placeholder="Amenities" value={workspaceData.amenities}
                onChange={handleInputChange}
                error={!workspaceData.amenities}
                helperText={!workspaceData.amenities ? "Mandatory Field" : ""}
              />
              <TextField
                select
                fullWidth
                margin="normal"
                label="Readiness Status"
                placeholder="Readiness Status"
                value={workspaceData.readinessStatus}
                onChange={(e) => setWorkspaceData({ ...workspaceData, readinessStatus: e.target.value })}
                error={!workspaceData.readinessStatus}
                helperText={!workspaceData.readinessStatus ? "Mandatory Field" : ""}
              >
                <MenuItem value="" disabled>Select</MenuItem>
                <MenuItem value="Ready">Ready</MenuItem>
                <MenuItem value="Not Ready">Not Ready</MenuItem>
                <MenuItem value="Maintenance">Maintenance</MenuItem>
              </TextField>
            </Box> */}
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                fullWidth label="Capacity" name="capacity" margin="normal"
                placeholder="Capacity" value={workspaceData.capacity}
                onChange={handleInputChange}
                error={!workspaceData.capacity}
                helperText={!workspaceData.capacity ? "Mandatory Field" : ""}
              />
              <TextField
                fullWidth label="Floor" name="floor" margin="normal"
                placeholder="Floor" value={workspaceData.floor}
                onChange={handleInputChange}
                error={!workspaceData.floor}
                helperText={!workspaceData.floor ? "Mandatory Field" : ""}
              />
            </Box>

            {/* <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #aaa",
                padding: 4,
                borderRadius: "12px",
                backgroundColor: "#fafafa",
                textAlign: "center",
                cursor: "pointer",
                position: "relative",
                height: "300px",
                mt: 2,
              }}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                const file = e.dataTransfer.files[0];
                handleFileUpload(file);
              }}
              onClick={() => fileInputRef.current?.click()}
            >
              {workspaceData.file ? (
                <img
                  src={URL.createObjectURL(workspaceData.file)}
                  alt="Preview"
                  style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                />
              ) : (
                <>
                  <PhotoCamera fontSize="large" />
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    Drag & drop or click to upload image
                  </Typography>
                </>
              )}
              <input
                hidden
                accept="image/png, image/jpeg, image/jpg"
                type="file"
                ref={fileInputRef}
                onChange={(e) => handleFileUpload(e.target.files[0])}
              />
              <Typography variant="caption" mt={1}>
                Max size: 5MB (.png, .jpg, .jpeg)
              </Typography>
            </Box> */}

            {/* Workspace Data */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Input Workspace Data
              </Typography>

              {/* Bagi kiri-kanan */}
              <Box sx={{ display: "flex", gap: 3 }}>
                {/* KIRI (Inspection Date & Periode Pemeriksaan) */}
                <Box sx={{ flex: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Inspection Date"
                      format="YYYY-MM-DD"
                      value={cleaningAdd.inspectionDate ? dayjs(cleaningAdd.inspectionDate) : null}
                      onChange={(newValue) =>
                        setCleaningAdd({
                          ...cleaningAdd,
                          inspectionDate: newValue ? newValue.format("YYYY-MM-DD") : null,
                        })
                      }
                      slotProps={{
                        textField: {
                          margin: "normal",
                          fullWidth: true,
                          sx: { mb: 1 },
                          name: "inspectionDate",
                          error: !cleaningAdd.inspectionDate,
                          helperText: !cleaningAdd.inspectionDate ? "Mandatory Field" : "",
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <TextField
                    select
                    fullWidth
                    margin="normal"
                    label="Periode Pemeriksaan"
                    placeholder="Periode Pemeriksaan"
                    name="inspectionPeriod"
                    value={cleaningAdd.inspectionPeriod || ""}
                    onChange={(e) =>
                      setCleaningAdd({ ...cleaningAdd, inspectionPeriod: e.target.value })
                    }
                    error={!cleaningAdd.inspectionPeriod}
                    helperText={!cleaningAdd.inspectionPeriod ? "Mandatory Field" : ""}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="1">Pukul 06.00 s/d 08.00 WIB</MenuItem>
                    <MenuItem value="2">Pukul 11.00 s/d 13.00 WIB</MenuItem>
                    <MenuItem value="3">Pukul 16.00 s/d 18.00 WIB</MenuItem>
                  </TextField>
                </Box>

                {/* KANAN (Status, Suhu, Plafon, dll) */}
                <Box sx={{ flex: 2 }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      select
                      fullWidth
                      margin="normal"
                      label="Status Lampu Penerangan"
                      placeholder="Status Lampu Penerangan"
                      name="lightingStatus"
                      value={cleaningAdd.lightingStatus || ""}
                      onChange={(e) =>
                        setCleaningAdd({ ...cleaningAdd, lightingStatus: e.target.value })
                      }
                      error={!cleaningAdd.lightingStatus}
                      helperText={!cleaningAdd.lightingStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>

                    <TextField
                      fullWidth
                      label="Suhu Ruangan"
                      name="roomTemperature"
                      margin="normal"
                      placeholder="Suhu Ruangan"
                      value={cleaningAdd.roomTemperature || ""}
                      onChange={(e) =>
                        setCleaningAdd({ ...cleaningAdd, roomTemperature: e.target.value })
                      }
                      error={!cleaningAdd.roomTemperature}
                      helperText={!cleaningAdd.roomTemperature ? "Mandatory Field" : ""}
                    />
                  </Box>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      select
                      fullWidth
                      margin="normal"
                      label="Status Plafon"
                      placeholder="Status Plafon"
                      name="ceilingStatus"
                      value={cleaningAdd.ceilingStatus || ""}
                      onChange={(e) =>
                        setCleaningAdd({ ...cleaningAdd, ceilingStatus: e.target.value })
                      }
                      error={!cleaningAdd.ceilingStatus}
                      helperText={!cleaningAdd.ceilingStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>

                    <TextField
                      select
                      fullWidth
                      margin="normal"
                      label="Status Stop Kontak"
                      placeholder="Status Stop Kontak"
                      name="socketStatus"
                      value={cleaningAdd.socketStatus || ""}
                      onChange={(e) =>
                        setCleaningAdd({ ...cleaningAdd, socketStatus: e.target.value })
                      }
                      error={!cleaningAdd.socketStatus}
                      helperText={!cleaningAdd.socketStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>
                  </Box>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      select
                      fullWidth
                      margin="normal"
                      label="Status Pintu"
                      placeholder="Status Pintu"
                      name="doorStatus"
                      value={cleaningAdd.doorStatus || ""}
                      onChange={(e) =>
                        setCleaningAdd({ ...cleaningAdd, doorStatus: e.target.value })
                      }
                      error={!cleaningAdd.doorStatus}
                      helperText={!cleaningAdd.doorStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>

                    <TextField
                      select
                      fullWidth
                      margin="normal"
                      label="Status Dinding"
                      placeholder="Status Dinding"
                      name="wallStatus"
                      value={cleaningAdd.wallStatus || ""}
                      onChange={(e) =>
                        setCleaningAdd({ ...cleaningAdd, wallStatus: e.target.value })
                      }
                      error={!cleaningAdd.wallStatus}
                      helperText={!cleaningAdd.wallStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>
                  </Box>
                </Box>
              </Box>

              {!isEditRowOnEdit && (
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ width: 180 }}
                  onClick={handleAddCleaningInfo}
                >
                  Tambahkan Workspace Data
                </Button>
              )}

              {isEditRow && (
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    sx={{ width: 180 }}
                    onClick={handleUpdateCleaningInfo}
                  >
                    Update Workspace Data
                  </Button>
                  <Button
                    variant="outlined"
                    color="warning"
                    size="small"
                    sx={{ width: 180 }}
                    onClick={handleCancelCleaningInfo}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </Box>

            {/* Section A - Workspace Data */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. Workspace Data</Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Workspace Name</TableCell>
                    <TableCell>Floor</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Periode</TableCell>
                    <TableCell>Suhu Ruangan</TableCell>
                    <TableCell>Lampu Penerangan</TableCell>
                    <TableCell>Stop Kontak</TableCell>
                    <TableCell>Plafon</TableCell>
                    <TableCell>Dinding</TableCell>
                    <TableCell>Pintu</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cleaningData.map((row, index) => (
                    <TableRow
                      key={index}
                      hover
                      onClick={() => handleRowAddClick(row)} // isi form ketika row diklik
                      style={{ cursor: "pointer" }}

                    >
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => {
                            handleDeleteCleaning(index);
                            // setRabDetailAdd((prev) => prev.filter((_, i) => i !== index));
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{workspaceData.workspaceName}</TableCell>
                      <TableCell>{workspaceData.floor}</TableCell>
                      <TableCell>{dayjs(row.inspectionDate).format("DD-MM-YYYY")}</TableCell>
                      <TableCell>{row.inspectionPeriod}</TableCell>
                      <TableCell>{row.roomTemperature}</TableCell>
                      <TableCell>{row.lightingStatus}</TableCell>
                      <TableCell>{row.socketStatus}</TableCell>
                      <TableCell>{row.ceilingStatus}</TableCell>
                      <TableCell>{row.wallStatus}</TableCell>
                      <TableCell>{row.doorStatus}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

            </Box>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddWorkspaceDialog(false)}>CANCEL</Button>
            <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddWorkspace}>SAVE</Button>
          </DialogActions>
        </Dialog>

        {/* POPUP Edit Workspace */}
        <Dialog open={openEditWorkspaceDialog} onClose={() => setOpenEditWorkspaceDialog(false)} fullWidth maxWidth="lg"
          sx={{ backdropFilter: "blur(5px)", borderRadius: "10px" }}>
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Typography variant="h6" fontWeight="bold">Workspace</Typography>
              <IconButton onClick={() => setOpenEditWorkspaceDialog(false)} color="error"><Close /></IconButton>
            </Box>
          </DialogTitle>

          <DialogContent>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Autocomplete
                disabled={!isEditing}
                fullWidth
                options={projectOptions}
                getOptionLabel={(option) => option.office.officeName || ""}
                value={projectOptions.find(opt => opt.id === editWorkspaceData.officeId) || null}
                onChange={(event, newValue) => {
                  handleInputChangeOnEdit({
                    target: {
                      name: "officeId",
                      value: newValue ? newValue.id : ""
                    }
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    disabled={!isEditing}
                    margin="normal"
                    label="Project Name" name="projectName"
                    placeholder="Enter project name"
                    fullWidth
                    error={!editWorkspaceData.officeId}
                    helperText={!editWorkspaceData.officeId ? "Mandatory Field" : ""}
                  />
                )}
              />
              <TextField
                disabled={!isEditing}
                fullWidth label="Workspace Name" name="workspaceName" margin="normal"
                placeholder="Workspace Name" value={editWorkspaceData.workspaceName}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.workspaceName}
                helperText={!editWorkspaceData.workspaceName ? "Mandatory Field" : ""}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                disabled={!isEditing}
                fullWidth label="Workspace Info" name="workspaceInfo" margin="normal"
                placeholder="Workspace Info" value={editWorkspaceData.workspaceInfo}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.workspaceInfo}
                helperText={!editWorkspaceData.workspaceInfo ? "Mandatory Field" : ""}
              />
            </Box>
            {/* <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                disabled={!isEditing}
                fullWidth label="Amenities" name="amenities" margin="normal"
                placeholder="Amenities" value={editWorkspaceData.amenities}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.amenities}
                helperText={!editWorkspaceData.amenities ? "Mandatory Field" : ""}
              />
              <TextField
                disabled={!isEditing}
                fullWidth label="Floor" name="floor" margin="normal"
                placeholder="Floor" value={editWorkspaceData.floor}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.floor}
                helperText={!editWorkspaceData.floor ? "Mandatory Field" : ""}
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                disabled={!isEditing}
                fullWidth label="Capacity" name="capacity" margin="normal"
                placeholder="Capacity" value={editWorkspaceData.capacity}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.capacity}
                helperText={!editWorkspaceData.capacity ? "Mandatory Field" : ""}
              />
              <TextField
                select
                disabled={!isEditing}
                fullWidth
                margin="normal"
                label="Readiness Status"
                placeholder="Readiness Status"
                value={editWorkspaceData.readinessStatus}
                onChange={(e) => setWorkspaceData({ ...workspaceData, readinessStatus: e.target.value })}
                error={!editWorkspaceData.readinessStatus}
                helperText={!editWorkspaceData.readinessStatus ? "Mandatory Field" : ""}
              >
                <MenuItem value="" disabled>Select</MenuItem>
                <MenuItem value="Ready">Ready</MenuItem>
                <MenuItem value="Not Ready">Not Ready</MenuItem>
                <MenuItem value="Maintenance">Maintenance</MenuItem>
              </TextField>
            </Box> */}
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                disabled={!isEditing}
                fullWidth label="Capacity" name="capacity" margin="normal"
                placeholder="Capacity" value={editWorkspaceData.capacity}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.capacity}
                helperText={!editWorkspaceData.capacity ? "Mandatory Field" : ""}
              />
              <TextField
                disabled={!isEditing}
                fullWidth label="Floor" name="floor" margin="normal"
                placeholder="Floor" value={editWorkspaceData.floor}
                onChange={handleInputChangeOnEdit}
                error={!editWorkspaceData.floor}
                helperText={!editWorkspaceData.floor ? "Mandatory Field" : ""}
              />
            </Box>

            {/* <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #aaa",
                padding: 4,
                borderRadius: "12px",
                backgroundColor: "#fafafa",
                textAlign: "center",
                cursor: "pointer",
                position: "relative",
                mt: 2,
              }}
              disabled={!isEditing}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                if (isEditing) {
                  e.preventDefault();
                  const file = e.dataTransfer.files[0];
                  handleEditFileUpload(file);
                }
              }}
              onClick={() => {
                if (isEditing) {
                  editFileInputRef.current?.click()
                }
              }}
            >
              {editWorkspaceData.file ? (
                // Jika user baru upload gambar
                <img
                  src={URL.createObjectURL(editWorkspaceData.file)}
                  alt="Preview"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    objectFit: "contain",
                    maxHeight: 180,
                  }}
                />
              ) : editWorkspaceData.previewUrl ? (
                // Jika sudah ada foto dari server
                <img
                  src={editWorkspaceData.previewUrl}
                  alt="Existing"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    objectFit: "contain",
                    maxHeight: 180,
                  }}
                />
              ) : (
                // Jika tidak ada gambar sama sekali
                <>
                  <PhotoCamera fontSize="large" />
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    Drag & drop or click to upload image
                  </Typography>
                </>
              )}

              <input
                hidden
                accept="image/png, image/jpeg, image/jpg"
                type="file"
                ref={editFileInputRef}
                onChange={(e) => handleEditFileUpload(e.target.files[0])}
              />
              <Typography variant="caption" mt={1}>
                Max size: 5MB (.png, .jpg, .jpeg)
              </Typography>
            </Box> */}

            {/* Workspace Data */}

            {/* Left Side (Inputs & Map) */}
            <Box sx={{ flex: 2, display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Input Workspace Data</Typography>
              <Box sx={{ display: "flex", gap: 3 }}>
                {/* KIRI (Inspection Date & Periode Pemeriksaan) */}
                <Box sx={{ flex: 1 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      disabled={!isEditing}
                      label="Inspection Date"
                      format="YYYY-MM-DD"
                      value={cleaningEdit.inspectionDate ? dayjs(cleaningEdit.inspectionDate) : null}
                      onChange={(newValue) =>
                        setCleaningEdit({
                          ...cleaningEdit,
                          inspectionDate: newValue ? newValue.format("YYYY-MM-DD") : null,
                        })
                      }
                      slotProps={{
                        textField: {
                          margin: "normal",
                          fullWidth: true,
                          sx: { mb: 1 },
                          name: "inspectionDate",
                          error: !cleaningEdit.inspectionDate,
                          helperText: !cleaningEdit.inspectionDate ? "Mandatory Field" : "",
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <TextField
                    select
                    fullWidth
                    disabled={!isEditing}
                    margin="normal"
                    label="Periode Pemeriksaan"
                    placeholder="Periode Pemeriksaan"
                    name="inspectionPeriod"
                    value={cleaningEdit.inspectionPeriod || ""}
                    onChange={(e) =>
                      setCleaningEdit({ ...cleaningEdit, inspectionPeriod: e.target.value })
                    }
                    error={!cleaningEdit.inspectionPeriod}
                    helperText={!cleaningEdit.inspectionPeriod ? "Mandatory Field" : ""}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="1">Pukul 06.00 s/d 08.00 WIB</MenuItem>
                    <MenuItem value="2">Pukul 11.00 s/d 13.00 WIB</MenuItem>
                    <MenuItem value="3">Pukul 16.00 s/d 18.00 WIB</MenuItem>
                  </TextField>
                </Box>

                {/* KANAN (Status, Suhu, Plafon, dll) */}
                <Box sx={{ flex: 2 }}>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      select
                      fullWidth
                      disabled={!isEditing}
                      margin="normal"
                      label="Status Lampu Penerangan"
                      placeholder="Status Lampu Penerangan"
                      name="lightingStatus"
                      value={cleaningEdit.lightingStatus || ""}
                      onChange={(e) =>
                        setCleaningEdit({ ...cleaningEdit, lightingStatus: e.target.value })
                      }
                      error={!cleaningEdit.lightingStatus}
                      helperText={!cleaningEdit.lightingStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>

                    <TextField
                      fullWidth
                      disabled={!isEditing}
                      label="Suhu Ruangan"
                      name="roomTemperature"
                      margin="normal"
                      placeholder="Suhu Ruangan"
                      value={cleaningEdit.roomTemperature || ""}
                      onChange={(e) =>
                        setCleaningEdit({ ...cleaningEdit, roomTemperature: e.target.value })
                      }
                      error={!cleaningEdit.roomTemperature}
                      helperText={!cleaningEdit.roomTemperature ? "Mandatory Field" : ""}
                    />
                  </Box>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      select
                      fullWidth
                      disabled={!isEditing}
                      margin="normal"
                      label="Status Plafon"
                      placeholder="Status Plafon"
                      name="ceilingStatus"
                      value={cleaningEdit.ceilingStatus || ""}
                      onChange={(e) =>
                        setCleaningEdit({ ...cleaningEdit, ceilingStatus: e.target.value })
                      }
                      error={!cleaningEdit.ceilingStatus}
                      helperText={!cleaningEdit.ceilingStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>

                    <TextField
                      select
                      fullWidth
                      disabled={!isEditing}
                      margin="normal"
                      label="Status Stop Kontak"
                      placeholder="Status Stop Kontak"
                      name="socketStatus"
                      value={cleaningEdit.socketStatus || ""}
                      onChange={(e) =>
                        setCleaningEdit({ ...cleaningEdit, socketStatus: e.target.value })
                      }
                      error={!cleaningEdit.socketStatus}
                      helperText={!cleaningEdit.socketStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>
                  </Box>

                  <Box sx={{ display: "flex", gap: 2 }}>
                    <TextField
                      select
                      fullWidth
                      disabled={!isEditing}
                      margin="normal"
                      label="Status Pintu"
                      placeholder="Status Pintu"
                      name="doorStatus"
                      value={cleaningEdit.doorStatus || ""}
                      onChange={(e) =>
                        setCleaningEdit({ ...cleaningEdit, doorStatus: e.target.value })
                      }
                      error={!cleaningEdit.doorStatus}
                      helperText={!cleaningEdit.doorStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>

                    <TextField
                      select
                      fullWidth
                      disabled={!isEditing}
                      margin="normal"
                      label="Status Dinding"
                      placeholder="Status Dinding"
                      name="wallStatus"
                      value={cleaningEdit.wallStatus || ""}
                      onChange={(e) =>
                        setCleaningEdit({ ...cleaningEdit, wallStatus: e.target.value })
                      }
                      error={!cleaningEdit.wallStatus}
                      helperText={!cleaningEdit.wallStatus ? "Mandatory Field" : ""}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="Baik">Baik</MenuItem>
                      <MenuItem value="Tidak Baik">Tidak Baik</MenuItem>
                    </TextField>
                  </Box>
                </Box>
              </Box>
              {!isEditRowOnEdit && (
                <Button
                  disabled={!isEditing}
                  variant="outlined"
                  color="primary"
                  size="small"
                  sx={{ width: 180 }}
                  onClick={handleAddCleaningInfoOnEdit}
                >
                  Tambahkan Workspace Data
                </Button>
              )}

              {isEditRowOnEdit && (
                <>
                  <Button
                    disabled={!isEditing}
                    variant="outlined"
                    color="primary"
                    size="small"
                    sx={{ width: 180 }}
                    onClick={handleUpdateCleaningInfoOnEdit}
                  >
                    Update Workspace Data
                  </Button>
                  <Button
                    disabled={!isEditing}
                    variant="outlined"
                    color="warning"
                    size="small"
                    sx={{ width: 180 }}
                    onClick={handleCancelCleaningInfoOnEdit}
                  >
                    Cancel
                  </Button>
                </>
              )}

              {/* </Box> */}

            </Box>

            {/* Section A - Workspace Data */}
            <Box sx={{ mt: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" gutterBottom>A. Workspace Data</Typography>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 2 }}
              >
                {/* Date Filters */}
                <Box display="flex" gap={2}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Date From"
                      format="YYYY-MM-DD"
                      value={startDateE ? dayjs(startDateE) : null}
                      onChange={(newValue) =>
                        setStartDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                      }
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          size: "small",
                          sx: { minWidth: 150 },
                        },
                      }}
                    />
                  </LocalizationProvider>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label="Date To"
                      format="YYYY-MM-DD"
                      value={endDateE ? dayjs(endDateE) : null}
                      onChange={(newValue) =>
                        setEndDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                      }
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          size: "small",
                          sx: { minWidth: 150 },
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Box>

                {/* Export Button */}
                <Button
                  onClick={exportWorkspaceDataToExcel}
                  variant="outlined"
                  startIcon={<Download />}
                  color="success"
                  sx={{ ml: 2 }}
                >
                  Export Excel
                </Button>
              </Box>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>No</TableCell>
                    <TableCell>Workspace Name</TableCell>
                    <TableCell>Floor</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Periode</TableCell>
                    <TableCell>Suhu Ruangan</TableCell>
                    <TableCell>Lampu Penerangan</TableCell>
                    <TableCell>Stop Kontak</TableCell>
                    <TableCell>Plafon</TableCell>
                    <TableCell>Dinding</TableCell>
                    <TableCell>Pintu</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    // cleaningDataOnEdit.length>0?
                    cleaningDataOnEdit.filter((row) => {
                      if (!startDateE && !endDateE) return true; // tidak ada filter

                      const inspectionDate = dayjs(row.inspectionDate);
                      const start = startDateE ? dayjs(startDateE) : null;
                      const end = endDateE ? dayjs(endDateE) : null;

                      if (start && end) {
                        return inspectionDate.isSameOrAfter(start) && inspectionDate.isSameOrBefore(end);
                      }
                      if (start) {
                        return inspectionDate.isSameOrAfter(start);
                      }
                      if (end) {
                        return inspectionDate.isSameOrBefore(end);
                      }
                      return true;
                    }).map((row, index) => (
                      <TableRow
                        key={index}
                        hover
                        onClick={() => (isEditing && handleRowEditClick(row, index))} // isi form ketika row diklik
                        style={{ cursor: "pointer" }}
                      >
                        <TableCell>
                          <IconButton
                            color="error"
                            disabled={!isEditing}
                            onClick={() => {
                              handleDeleteCleaningOnEdit(index);
                              // setRabDetailAdd((prev) => prev.filter((_, i) => i !== index));
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </TableCell>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{editWorkspaceData.workspaceName}</TableCell>
                        <TableCell>{editWorkspaceData.floor}</TableCell>
                        <TableCell>{dayjs(row.inspectionDate).format("DD-MM-YYYY")}</TableCell>
                        <TableCell>{row.inspectionPeriod}</TableCell>
                        <TableCell>{row.roomTemperature}</TableCell>
                        <TableCell>{row.lightingStatus}</TableCell>
                        <TableCell>{row.socketStatus}</TableCell>
                        <TableCell>{row.ceilingStatus}</TableCell>
                        <TableCell>{row.wallStatus}</TableCell>
                        <TableCell>{row.doorStatus}</TableCell>
                      </TableRow>
                    ))
                    // : <TableRow>Loading</TableRow>
                  }
                </TableBody>
              </Table>

            </Box>
          </DialogContent>


          {/* Dialog Actions */}
          <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
            {!isEditing ? (
              // Tombol Edit Muncul di Awal
              <Button onClick={() => setIsEditing(true)} variant="contained" color="primary" sx={{ width: 120 }}>
                EDIT
              </Button>
            ) : (
              // Tombol Save & Cancel Muncul Saat Edit
              <>
                <Button onClick={() => { setIsEditing(false) }} variant="outlined" color="error" sx={{ width: 120 }}>
                  CANCEL
                </Button>
                <Button onClick={handleSubmitEditWorkspace} variant="contained" color="success" sx={{ width: 120 }}>
                  SAVE
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>




        {/* ======================= Filter Dialog ============================= */}
        <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
          <DialogTitle>Advanced Search</DialogTitle>
          <DialogContent>
            {filters.map((filter, index) => {
              const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
              const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

              return (
                <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                  <TextField
                    select
                    value={filter.field}
                    onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                    variant="outlined"
                    size="small"
                    sx={{ mt: 1, minWidth: 160 }}
                  >
                    {availableOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  {filter.field === "officeId" ? (
                    <TextField
                      select
                      label="Office Project"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {projectOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.office.officeName}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "approver" ? (
                    <TextField
                      select
                      label="Approver"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {employeeOptions.map((option) => (
                        <MenuItem key={option.id} value={option.nik}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "pembebanan" ? (
                    <TextField
                      select
                      label="Pembebanan"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {pembebanan.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "status" ? (
                    <TextField
                      select
                      label="Status"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1, minWidth: 160 }}
                    >
                      {statuses.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : filter.field === "startDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateS ? dayjs(startDateS) : null}
                          onChange={(newValue) =>
                            setStartDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateS ? dayjs(endDateS) : null}
                          onChange={(newValue) =>
                            setEndDateS(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "endDate" ? (
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="Start Date"
                          format="YYYY-MM-DD"
                          value={startDateE ? dayjs(startDateE) : null}
                          onChange={(newValue) =>
                            setStartDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>

                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          label="End Date"
                          format="YYYY-MM-DD"
                          value={endDateE ? dayjs(endDateE) : null}
                          onChange={(newValue) =>
                            setEndDateE(newValue ? newValue.format("YYYY-MM-DD") : null)
                          }
                          slotProps={{
                            textField: {
                              variant: "outlined",
                              size: "small",
                              sx: { mt: 1, minWidth: 150 },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </>
                  ) : filter.field === "valueEstimation" ? (
                    <>
                      <TextField
                        label="Value Min"
                        variant="outlined"
                        size="small"
                        value={valueMin}
                        onChange={(e) =>
                          setValueMin(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                      <TextField
                        label="Value Max"
                        variant="outlined"
                        size="small"
                        value={valueMax}
                        onChange={(e) =>
                          setValueMax(e.target.value)
                        }
                        sx={{ mt: 1 }}
                      />
                    </>

                  ) : (
                    <TextField
                      label="Value"
                      variant="outlined"
                      size="small"
                      value={filter.value}
                      onChange={(e) =>
                        handleFilterChange(index, "value", e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  )}

                  {index > 0 && (
                    <IconButton onClick={() => handleRemoveFilter(index)}>
                      <Remove />
                    </IconButton>
                  )}
                </Box>
              );
            })}

            {filters.length < availableFilters.length && (
              <Button startIcon={<Add />} onClick={handleAddFilter}>
                Add Filter
              </Button>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleResetFilters}>Reset Filter</Button>
            <Button onClick={handleCloseFilter}>Cancel</Button>
            <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
              {isLoading ? "Loading..." : "Apply"}
            </Button>
          </DialogActions>
        </Dialog>

      </Box >
  );
};

export default WorkspacePage;
